import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { getDraftFullId } from "../../../Forms/Types/FormSettings";

import { UserPicklistDeclaration } from "./UserPicklistDeclaration";

const mapStateToProps = (state: FullFormState) => ({
    draftId: getDraftFullId(state.settings),
    keformsUrl: state.settings.keformsUrl,
    referenceKey: [state.settings.abonId, state.settings.orgId, state.settings.userId].join("-"),
});

export const UserPicklistDeclarationContainer = connect(mapStateToProps)(UserPicklistDeclaration);
